
export const SEARCHABLE_CONST_DOCUMENT = 2;
export const SEARCHABLE_CONST_WEBSITESCRAPE_CONST = 3;

export type SEARCHABLE_TYPE_DOCUMENT = 2;
export type SEARCHABLE_TYPE_WEBSITESCRAPE = 3;

export type AllSearchableItemType<ID = string> = SearchableItemDocument<ID> | SearchableItemWebscrapePage<ID>
//Global Searchable Item
export type SearchableItemBase<ID = string> = {
  _id: ID,
  embeddings: number[],
  value: string,
  type: number,
  updated: Date,
  parentId: ID,  // Id of parent doc or parent websitescrapte
  chunk: number
}

export type SearchableItemDocument<ID = string> = SearchableItemBase<ID> & {
  type: SEARCHABLE_TYPE_DOCUMENT

}
export type SearchableItemWebscrapePage<ID = string> = SearchableItemBase<ID> & {
  url: string,
  rootUrl: string,
  links: string[],
  type: SEARCHABLE_TYPE_WEBSITESCRAPE
}